import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {HttpService} from "../../../_service/http.service";
import "rxjs/add/operator/filter";
import {Metrika} from "ng-yandex-metrika";
import {ActivatedRoute} from "@angular/router";
import {PaySaldoService} from "../pay-saldo.service";
import {PaymentUserData} from "../models/payment-user-data";
import {PaymentDeviceType} from "../models/payment-device-type";
import {PaymentData} from "../models/payment-data";
import {WidgetSaldo} from "../../../main-page/account-part/widget-saldo";
import {PaymentOption} from "../models/payment-option";
import { ImageType } from "../models/image-type";
import {BsModalRef, ModalDirective} from "ngx-bootstrap";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({
  templateUrl: './new-widget-saldo-info.component.html',
  selector: 'new-app-widget-saldo-info',
  styleUrls: ['../../../../styles.css']
})
export class NewWidgetSaldoInfoComponent implements OnInit {

  @Output()
  errorEvent = new EventEmitter();
  @Input()
  public saldo: WidgetSaldo;
  @Input()
  alias;
  @Input()
  isFromSite = false;

  @ViewChild('qrCodePaymentModal') qrCodePaymentModal: ModalDirective;

  public modalRef: BsModalRef;


  emailField: any;
  isRequestCounting = false;
  balanceStatus: any;
  balanceDisplay: any;
  toPayDisplay: any;

  public ImageType = ImageType;
  public paymentData: PaymentData;
  public paymentOptions: Array<PaymentOption>;
  public qrCodeString: SafeUrl;

  constructor(private metrika: Metrika,
              private route: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private httpService: HttpService,
              private payService: PaySaldoService) {
  }

  ngOnInit(): void {
    this.toPayDisplay = this.saldo.toPay;
    this.balanceDisplay = Math.abs(this.saldo.balance);
    this.balanceStatus = this.getBalanceStatus(this.saldo.balance);
    this.emailField = this.saldo.ownerEmail;

    this.getPaymentOptions();
  }


  postUserPayment(paymentOption: PaymentOption) {

    if(!this.isFormValid(paymentOption)){
      return;
    }

    let userPaymentData = this.getUserPaymentData(paymentOption, this.saldo);

    this.payService.postUserPayment(userPaymentData)
        .then((paymentData: PaymentData) => {
            this.paymentData = paymentData;
            this.paymentData.paymentOption = paymentOption;
            this.handlePaymentData(this.paymentData, paymentOption);
        }, (error) => {
          this.errorHandler(error);
          console.error("PostUserPayment error", error);
        })

  }

  private getUserPaymentData(paymentOption: PaymentOption, saldo: WidgetSaldo): PaymentUserData {
    return new PaymentUserData(paymentOption.languageCode, PaymentDeviceType.LK_AUTHORIZED,
        saldo.toPay, this.saldo.accountId, "", this.saldo.ownerEmail,
        paymentOption.token);
  }


  private isFormValid(paymentOption: PaymentOption): boolean {
    let errorMessage = '';
    if (this.saldo.toPay == null || this.saldo.toPay === '') {
      errorMessage += 'Поле \'К оплате\' обязательно для заполнения\n';
    }

    if(paymentOption.isEmailRequired) {
      if(this.emailField == null || this.emailField === ''){
        errorMessage += 'Введите Ваш Email для получения подтверждения платежа';
      } else {
        const validateEmailErrorMessage = this.validateEmail(this.emailField);
        errorMessage += validateEmailErrorMessage;
      }
    }

    this.errorEvent.emit({data: errorMessage});

    return errorMessage === '';
  }


  errorHandler(error: any) {
    let errorMessage = '';
    this.isRequestCounting = false;
    // this.saldo = null;
    if (error._body.type !== undefined && error._body.type === 'error') {
      errorMessage = 'Не удалось связаться с сервисом. Повторите попытку позже.';
    } else {
      errorMessage = error._body;
    }

    this.errorEvent.emit({data: errorMessage});
    console.log('Error in get account state: ', error._body);
  }


  getBalanceStatus(balance: any) {
    if (balance < 0) {
      return {text: 'К оплате', symbol: ''};
    } else if (balance === 0) {
      return {text: 'Баланс', symbol: ''};
    } else {
      return {text: 'Переплата', symbol: '+'};
    }
  }


  notFindMessage() {
    let result = '';
    if (this.saldo.balance == null) {
      result += 'балансе';
    }
    if (this.saldo.balance == null && this.saldo.billAmount == null) {
      result += ' и ';
    }
    if (this.saldo.billAmount == null) {
      result += 'начислениях за этот месяц';
    }
    return result;
  }

  validateEmail(email: string): string {
    const emailReg = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/, 'mgi');
    if (!emailReg.test(email)) {
      return 'Проверьте правильность введенного Email адреса';
    }
    return '';
  }


  moneyInputPatternCheck() {
    this.saldo.toPay = this.saldo.toPay.match('^[0-9]*([,.]?[0-9]{1,2})?')[0];
    this.saldo.toPay = this.saldo.toPay.replace(',', '.');
  }


  private getPaymentOptions() {
    this.payService.getPaymentOptions(this.saldo.accountId, PaymentDeviceType.LK_AUTHORIZED)
        .then(
            (data: Array<PaymentOption>) => this.paymentOptions = data,
            (error) => {
                  console.error(error);
            });
  }


  private handlePaymentData(paymentData: PaymentData, paymentOption: PaymentOption) {
      if(paymentOption.token == "SBP_SELLER_QR" || paymentData.qrCodeBase64 != null){
        this.qrCodeString = this.sanitizer.bypassSecurityTrustUrl(paymentData.qrCodeBase64);
        this.showQrCodePaymentWindow();
        console.debug("Showing qrcode window");
      } else {
        this.redirectToPaymentService(paymentData);
      }
  }


  private showQrCodePaymentWindow() {
    this.qrCodePaymentModal.show();
  }

  public hideQrCodePaymentWindow() {
    this.qrCodePaymentModal.hide();
  }

  private redirectToPaymentService(paymentData: PaymentData) {
    console.log('Received data in getSuitableAddress is: ', paymentData);
    this.metrika.fireEvent('START_PAYMENT');
    if (window.top !== undefined) {
      window.top.location.href = paymentData.externalURL;
    } else {
      window.location.href = paymentData.externalURL;
    }
  }


  private showErrorMessage(errorMessage: string) {

  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/new-widget-saldo-info/new-widget-saldo-info.component.ts